
        <div class="Loader" [ngClass]="{'Loader--loading': (isLoading | async)}">
            <div class="text-center">
                Attendere prego...<br>
                <div class="spinner-border text-secondary mt-3" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    